import CreditLossBasic from './credit-loss-basic'
import CreditLossDetailed from './credit-loss-detailed'
import CommissionBasic from './commission-basic'
import CommissionDetailed from './commission-detailed'
import DeleteConfirmation from './delete-confirmation'
import FreeRentBasic from './free-rent-basic'
import FreeRentDetailed from './free-rent-detailed'
import MakeReadyBasic from './make-ready-basic'
import MakeReadyDetailed from './make-ready-detailed'
import RentBasic from "./rent-basic.tsx"
import RentDetailed from './rent-detailed.tsx'
import OccupiedRolloverBasic from './occupied-rollover-basic'
import OccupiedRollverDetailed from './occupied-rollover-detailed'
import UnitEndDisplay from './unit-end-display'
import UnitEndEdit from './unit-end-edit'
import UnitStartDisplay from './unit-start-display'
import UnitStartEdit from './unit-start-edit'
import VacantLeaseupDisplay from './vacant-leaseup-display'
import VacantLeaseupBasic from './vacant-leaseup-basic'
import VacantLeaseupDetailed from './vacant-leaseup-detailed'
import VacancyLossBasic from './vacancy-loss-basic'
import VacancyLossDetailed from './vacancy-loss-detailed'

export default {
  CommissionBasic,
  CommissionDetailed,
  CreditLossBasic,
  CreditLossDetailed,
  DeleteConfirmation,
  FreeRentBasic,
  FreeRentDetailed,
  MakeReadyBasic,
  MakeReadyDetailed,
  RentBasic,
  RentDetailed,
  OccupiedRolloverBasic,
  OccupiedRollverDetailed,
  VacantLeaseupDisplay,
  VacantLeaseupBasic,
  VacantLeaseupDetailed,
  UnitEndDisplay,
  UnitEndEdit,
  UnitStartDisplay,
  UnitStartEdit,
  VacancyLossBasic,
  VacancyLossDetailed
}
